module.exports = __webpack_public_path__ + "img/bg_faq.abca9f35.png";